import { Box } from '@mui/material'
import React from 'react'
import { PreDefinedFilters } from './PreDefinedFilters'
import { PreDefinedFilterTypes } from './utility'

export function AllPreDefinedFilters({
  treeId,
  versionId,
}: {
  treeId: string
  versionId: string
}) {
  return (
    <Box>
      <Box>All Pre Defined Operations</Box>
      <PreDefinedFilters
        treeId={treeId}
        versionId={versionId}
        filters={Object.values(PreDefinedFilterTypes)}
      />
    </Box>
  )
}
